__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-player-taste/v4_0_3/";